import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import { PASearch, ISearchRequest } from "../PA.Core/PASearch";
import { SearchUtils } from "../PA.UIM.Core/SearchUtils";
import { PAEnvironment } from "../PA.Core/PAEnvironment";
import { CustomerSearch } from "../PA.UIM.MD/CustomerSearch";
import { PlanningLevelSearch } from "./PlanningLevelSearch";
import { EventTypeSearch } from "../PA.UIM.MD/EventTypeSearch";
import { PlanSearch } from "./PlanSearch";
import * as _ from "lodash";


const EventSearch: ISearch = {
    searchName: "Find Event",
    renderOptions: { ui5ResourceId: "EventSearch" },
    searchProfileIdDefault: "default",
    searchProfiles: []
}

const vUI_Event_Search_Fields: { [id: string]: ISearchProviderField } = {

    WB_EVT_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: 'WB Event Id', columnResourceName: 'colwbId', alignment: HorizAlignment.Center },
        domainOptions: {}
    },
    EVENT_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Event Id', columnResourceName: 'colId', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 }
    },
    EVENT_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Event Name', columnResourceName: 'colName', alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 256 }
    },
    WB_PLAN_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Plan Id',
            columnResourceName: 'colwbPlanId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    PLAN_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Plan ID', columnResourceName: 'colPlanID', alignment: HorizAlignment.Left },
        domainOptions: {}
    },
    PLAN_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Plan Name', columnResourceName: 'colPlanName', alignment: HorizAlignment.Left },
        domainOptions: {}
    },
    PLAN_NAMEID: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: 'Plan', columnResourceName: 'colPlanNameID', alignment: HorizAlignment.Left },
        domainOptions: {}
    },
    EVENT_TYPE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Event Type ID',
            columnResourceName: 'colEventTypeID',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    EVENT_TYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Event Type Name',
            columnResourceName: 'colEventTypeName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            search: EventSearch,
            profileId: "default",
            bUseSearchProvidersDistinctValues: true,
            maxLength: 256
        }
    },
    EVENT_TYPE_NAMEID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Event Type',
            columnResourceName: 'colEventTypeName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    STATUS_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Status ID',
            columnResourceName: 'colEventStatusID',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    STATUS_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Status Name',
            columnResourceName: 'colEventStatusName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    STATUS_NAMEID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Status',
            columnResourceName: 'colEventStatusName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    },
    WORKFLOW_STATUS_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WorkFlow Status',
            columnResourceName: 'colWorkFlowStatus',
            alignment: HorizAlignment.Right
        },
        domainOptions: {}
    },
    WB_CUST_ID_PLANNING: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Planning Cust WB Id',
            columnResourceName: 'colPlnCstId',
            alignment: HorizAlignment.Center
        },
        domainOptions: { search: CustomerSearch, profileId: "MyPlanningCustomers", searchCondition: {} }
    },
    PLANNINGCUSTOMER: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Planning Customer',
            columnResourceName: 'colPlanningCustomer',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    },
    SUBPLANNINGCUSTOMER: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Sub Planning Customer',
            columnResourceName: 'colSubPlanningCustomer',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    },
    INSTORE_START_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'In Store Start Date',
            columnResourceName: 'colInStoreStart',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    INSTORE_END_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'In Store End Date',
            columnResourceName: 'colInStoreEnd',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    SHIPMENT_START_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Shipment Start Date',
            columnResourceName: 'colShipmentStart',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    SHIPMENT_END_DT: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Shipment End Date',
            columnResourceName: 'colShipmentEnd',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    WB_SALESORG_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'Sales Org WB Id',
            columnResourceName: 'colSalesOrgWBId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    SALESORG_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Sales Org Name',
            columnResourceName: 'colSalesOrgName',
            alignment: HorizAlignment.Center
        },
        domainOptions: { search: EventSearch, profileId: "default", bUseSearchProvidersDistinctValues: true }
    },
    EVENT_LAYER: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Event Layer',
            columnResourceName: 'colEventLayer',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}
    }

}

const EventSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id: 'WB_EVT_ID',
        id_ui: 'EVENT_ID',
        name: 'EVENT_NAME',
        source_id: 'SOURCE_ID'
    },

    searchProviderFields: vUI_Event_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)

            searchRequestSubset.where['WB_SALESORG_ID'] = { inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID') }

            const findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Event_Search',
                this.searchProviderFields,
                [])

            async function getEvents() {
                const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
                if (!usrContext.hasRoleId("VIEW_ALL")) {
                    await SearchUtils.addUserGroupPlansFilter(findRequest, 'WB_PLAN_ID')
                }

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(res)
                    })
                    .catch((err) => {
                        error(err)
                    })
            }

            getEvents()
        })
    },

    // Filter with drop down in the TPM Event Search
    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
            const salesorgs = _.map(usrContext.WB_SalesOrgs, 'SALESORG_NAME')
            const findRequest = SearchUtils.makeSearchRequest({ where: { SALESORG_NAME: { inq: salesorgs } } },
                'vUI_Event_Search',
                this.searchProviderFields,
                [fieldName])

            async function getEvents() {
                const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
                if (!usrContext.hasRoleId("VIEW_ALL")) {
                    await SearchUtils.addUserGroupPlansFilter(findRequest, 'WB_PLAN_ID')
                }

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(_.map(res, (aRow) => {
                            return aRow[fieldName]
                        }))
                    })
                    .catch((err) => {
                        error(err)
                    })
            }

            getEvents()
        })
    }

}

const EventSearchProviderMerging: ISearchProvider = {

    keyFields: {
        id: 'WB_EVT_ID',
        id_ui: 'EVENT_ID',
        name: 'EVENT_NAME',
        source_id: 'SOURCE_ID'
    },

    searchProviderFields: vUI_Event_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)

            searchRequestSubset.where['WB_SALESORG_ID'] = { inq: _.map(usrContext.WB_SalesOrgs, 'WB_SALESORG_ID') }

            const findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Event_Search',
                this.searchProviderFields,
                [])

            async function getEvents() {
                const usrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
                if (!usrContext.hasRoleId("VIEW_ALL")) {
                    await SearchUtils.addUserGroupPlansFilter(findRequest, 'WB_PLAN_ID')
                }

                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(res)
                    })
                    .catch((err) => {
                        error(err)
                    })
            }

            getEvents()
        })
    }

}


const EventSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "EventSearchProfileByName" },

    profileFilter: [
        { profileFilterName: 'Id', searchProviderFieldId: 'EVENT_ID', renderOptions: {} },
        { profileFilterName: 'Name', searchProviderFieldId: 'EVENT_NAME', renderOptions: {} },
        { profileFilterName: 'Type', searchProviderFieldId: 'EVENT_TYPE_NAME', bMultiSelect: true, renderOptions: {} },
        { profileFilterName: 'Plan', searchProviderFieldId: 'PLAN_NAMEID', renderOptions: {} },
        {
            profileFilterName: 'Customer',
            searchProviderFieldId: 'WB_CUST_ID_PLANNING',
            bMultiSelect: true,
            renderOptions: {}
        },
        {
            profileFilterName: 'Sales Org',
            searchProviderFieldId: 'SALESORG_NAME',
            bMultiSelect: true,
            renderOptions: {}
        }
    ],  // ISearchFields
    profileDisplayFields: [
        'EVENT_ID', 'EVENT_NAME', 'PLANNINGCUSTOMER', 'SUBPLANNINGCUSTOMER', 'EVENT_TYPE_NAME', 'PLAN_NAMEID', 'SALESORG_NAME', 'INSTORE_START_DT', 'INSTORE_END_DT', 'SHIPMENT_START_DT', 'SHIPMENT_END_DT', {
            columnTitle: "Lock",
            lockClass: "Event",
            lockIdFieldName: "WB_EVT_ID",
            bDisplayLockIcon: true,
            bDisplayLockOwner: true
        }
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: EventSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const EventSearchProfileNoLock: ISearchProfile = {
    profileId: "NoLock",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "EventSearchProfileNoLock" },

    profileFilter: [
        { profileFilterName: 'Id', searchProviderFieldId: 'EVENT_ID', renderOptions: {} },
        { profileFilterName: 'Name', searchProviderFieldId: 'EVENT_NAME', renderOptions: {} },
        { profileFilterName: 'Type', searchProviderFieldId: 'EVENT_TYPE_NAME', bMultiSelect: true, renderOptions: {} },
        { profileFilterName: 'Plan', searchProviderFieldId: 'PLAN_NAMEID', renderOptions: {} },
        {
            profileFilterName: 'Customer',
            searchProviderFieldId: 'WB_CUST_ID_PLANNING',
            bMultiSelect: true,
            renderOptions: {}
        },
        {
            profileFilterName: 'Sales Org',
            searchProviderFieldId: 'SALESORG_NAME',
            bMultiSelect: true,
            renderOptions: {}
        }
    ],  // ISearchFields
    profileDisplayFields: [
        'EVENT_ID', 'EVENT_NAME', 'PLANNINGCUSTOMER', 'SUBPLANNINGCUSTOMER', 'EVENT_TYPE_NAME', 'PLAN_NAMEID', 'SALESORG_NAME', 'INSTORE_START_DT', 'INSTORE_END_DT', 'SHIPMENT_START_DT', 'SHIPMENT_END_DT'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: EventSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const EventSearchProfileForMerging: ISearchProfile = {
    profileId: "eventMerging",
    profileName: "Search Event",
    renderOptions: { ui5ResourceId: "EventSearchProfileForMerging" },

    profileFilter: [
        { profileFilterName: 'Id', searchProviderFieldId: 'EVENT_ID', renderOptions: {} },
        { profileFilterName: 'Name', searchProviderFieldId: 'EVENT_NAME', renderOptions: {} }
    ],  // ISearchFields
    profileDisplayFields: [
        'EVENT_ID', 'EVENT_NAME', 'PLANNINGCUSTOMER', 'SUBPLANNINGCUSTOMER', 'EVENT_TYPE_NAME', 'PLAN_NAMEID', 'SALESORG_NAME', 'INSTORE_START_DT', 'INSTORE_END_DT', 'SHIPMENT_START_DT', 'SHIPMENT_END_DT', {
            columnTitle: "Lock",
            lockClass: "Event",
            lockIdFieldName: "WB_EVT_ID",
            bDisplayLockIcon: true,
            bDisplayLockOwner: true
        }
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: EventSearchProviderMerging,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

EventSearch.searchProfiles = [EventSearchProfileByName, EventSearchProfileForMerging, EventSearchProfileNoLock]

PAEnvironment.registerBusinessObjectSearch("EventBO", "Event", EventSearch, "Event Search")

export { EventSearch }